<template>
    <div>

        <div v-show="now.includes('KGS')" class="magsg">
            <InputNumber size="small" style="width:60px;" v-model="kgs"></InputNumber>/KGS
        </div>
        <div v-show="now.includes('CBM')" class="magsg">
            <InputNumber size="small" style="width:60px;" v-model="cbm"></InputNumber>/CBM
        </div>
        <div v-show="now.includes('P/L')" class="magsg">
            <InputNumber size="small" style="width:60px;" v-model="pl"></InputNumber>/PL
        </div>
        <div v-show="now.includes('件')" class="magsg">
            <InputNumber size="small" style="width:60px;" v-model="jian"></InputNumber>/件
        </div>
    </div>
</template>
<script>
export default {
    props: ["bbb", "now",],
    model: {
        prop: "bbb",
        event: "aaa",
    },
    data() {
        return {
            kgs: 0,
            cbm: 0,
            pl: 0,
            jian: 0,
            obj: {
                KGS: {
                    show: true,
                    key: 'kgs'
                },
                CBM: {
                    show: true,
                    key: 'kgs'
                },
                'P/L': {
                    show: true,
                    key: 'pl'
                },
                件: {
                    show: true,
                    key: 'kgs'
                }

            }

        }
    },
    methods: {
        tt() {
            //console.log(this.bbb);
            eval('this.' + this.bbb);

        },
        rangeZhuangXie(a, b, c, d) {
            this.kgs = a;
            this.cbm = b;
            this.pl = c;
            this.jian = d;
        },
        emit() {
            this.$emit('aaa', "rangeZhuangXie(" +
                this.kgs + "," +
                this.cbm + "," +
                this.pl + "," +
                this.jian +
                ")")
        }
    },
    mounted() {
        this.tt();
    },
    watch: {
        kgs(v) {
            this.emit();
            var t = [];

        },
        cbm() {
            this.emit();
        },
        pl() {
            this.emit();
        },
        jian() {
            this.emit();
        },
        bbb() {
            this.tt();
        },
        now() {
            // var kgs=this.kgs,cbm=this.cbm,pl=this.pl,jian=this.jian;

            console.log(this.now);
            if (!this.now.includes('KGS')) {
                this.kgs = 0;
            }
            if (!this.now.includes('CBM')) {
                this.cbm = 0;
            }
            if (!this.now.includes('P/L')) {
                this.pl = 0;
            }
            if (!this.now.includes('件')) {
                this.jian = 0;
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/gongshi/rangeZhuangXie.vue